export const APP_NAME = 'Electride';
export const API_URL = 'https://api.electridesrsw.com/api/';
export const SOCKET_URL = 'https://api.electridesrsw.com';
export const hereApiKey = 'JCACEpq17xj81A5lYG4YmcqfBmqcHO7KHyInkC7Q0ZM';
export const hereMapApiRevgeocode = 'https://revgeocode.search.hereapi.com/v1/revgeocode';
export const hereMapApirouter = 'https://router.hereapi.com/v8/routes';
export const hereMapApiSearch = 'https://autosuggest.search.hereapi.com/v1/autosuggest';
